// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"99e64988","709":"82fb27e6","787":"3aeda83d","935":"ede9e1cd"}[chunkId] + ".chunk.js";
};